export default __webpack_public_path__ + "ea9bea681e37503f4d4a49470a1d37a7.png";